import styled, { css } from 'styled-components';
import { colors, fonts } from 'stylesheets';
import pedidosAbertosIcon from 'assets/img/card-pedidos-abertos.png';
import pagamentoPendenteIcon from 'assets/img/card-pagamento-pendente.png';
import gifStatusEmpty from 'assets/img/relatorio-estado-vazio.gif';

export const TitleBox = styled.p`
  font: 500 14px ${fonts.secondary};
  color: ${colors.greyDark};
  text-transform: uppercase;
`;

export const Container = styled.div`
  width: 100%;
  height: 600px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
`;

export const ContainerEmpty = styled.div`
  width: 100%;
  height: 615px;
  background: ${colors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  padding: 25px;
`;

export const Numbers = styled.div`
  width: 22.7%;
  height: 200px;
  padding-top: 10px;
  background: ${colors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  position: relative;
  &:hover {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    transition: box-shadow 0.2s;
  }
  ${({ isAmount }) => isAmount
    && css`
      padding-top: 35px;
    `}
`;

export const Icon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 100%;
  margin: 10px auto;
  box-shadow: 0px 0px 4px ${({ color }) => (color === 'green' ? '#59BC5C' : '#3E81F7')};
  background: url(${({ color }) => (color === 'green' ? pagamentoPendenteIcon : pedidosAbertosIcon)})no-repeat center;
`;

export const Number = styled.span`
  display: block;
  font-family: ${fonts.secondary};
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  color: ${colors.greyDark};
  ${({ isAmount }) => isAmount
    && css`
      font-size: 25px;
      margin: 15px 0px;
      span {
        color: ${colors.greyLight};
        font-size: 12px;
      }
    `}
`;

export const Label = styled.span`
  display: block;
  font-family: ${fonts.primary};
  font-size: 12px;
  text-align: center;
  color: ${colors.greyDark};
  ${({ isAmount }) => isAmount
    && css`
      color: ${colors.greyMedium}
      font-size: 13px;
    `}
`;

export const SeeMore = styled.span`
  display: block;
  color: ${colors.primary};
  text-transform: uppercase;
  font: 500 10px ${fonts.primary};
  text-align: center;
  margin-top: 15px;
`;

export const Section = styled.div`
  width: 48.5%;
  height: 200px;
  padding-top: 10px;
  background: ${colors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  position: relative;
  &:hover {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    transition: box-shadow 0.2s;
  }
`;

export const Card = styled.div`
  width: 48.5%;
  min-height: 300px;
  margin-top: 20px;
  padding: 32px 21px 0px 21px;
  background: ${colors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  position: relative;
  &:hover {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    transition: box-shadow 0.2s;
  }
`;

export const TitleCard = styled.p`
  font-family: ${fonts.primary};
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 20px;
  color: ${colors.greyDark};
  text-transform: uppercase;
`;

export const Bar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 22px;
`;

export const Name = styled.span`
  font-family: ${fonts.primary};
  font-size: 12px;
  color: ${colors.greyDark};
  display: inline-block;
  margin-right: 77px;
  width: 40%;
`;

export const Full = styled.div`
  width: 100%;
  border-radius: 90px;
  height: 11px;
`;

export const Progress = styled.div`
  width: ${({ percent }) => percent};
  height: 11px;
  height: inherit;
  background: linear-gradient(270deg, #FF6000 0%, #FF9600 100%);
  border-radius: 90px;
`;

export const BoxLoader = styled.div`
  position: absolute;
  top: 50%;
  margin: 0 auto;
  left: 50%;
  right: 50%;
`;

export const Gif = styled.div`
  width: 285px;
  height: 239px;
  background: url(${gifStatusEmpty})no-repeat center;
  background-size: cover;
  margin: 80px auto 0px auto;
`;

export const Title = styled.div`
  font: 14px ${fonts.primary};
  font-weight: bold;
  text-transform: uppercase;
  color: ${fonts.greyDark};
  margin-top: 28px;
  text-align: center;
  margin-bottom: 15px;
`;

export const Desc = styled.div`
  font: 13px ${fonts.primary};
  color: ${fonts.greyDark};
  width: 45%;
  margin: 0 auto;
  text-align: center;
`;
